export default {
  fields: {
    email: 'E-Mail-Adresse',
    postcode: 'Postleitzahl',
    title: 'Anrede',
    firstName: 'Vorname',
    lastName: 'Nachname',
    mobilePhone: 'Mobiltelefon',
    dateOfBirth: 'Geburtsdatum',
    birthday: 'Geburtstag',
    fullAddress: 'Vollständige Adresse',
    accept: {
      0: 'Ich akzeptiere die',
      1: 'Ich bin über 13 Jahre und akzeptiere die',
      2: 'Ich bin über 16 Jahre und akzeptiere die',
      3: 'Ich bin über 18 Jahre und akzeptiere die',
      4: 'Ich bin über 21 Jahre und akzeptiere die'
    }
  }
};